import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function HeroSection() {
  const painPoints = ['Si el 80% de tus llamadas son de gente que pregunta el precio y luego desaparece', 'Si Yelp y los directorios te cobran por leads que nunca cierran', 'Si en temporada baja tu flota está parada sin trabajo', 'Si has tenido malas reseñas que dañan tu reputación online aunque seas una empresa seria', 'Si dependes de la temporada de verano para sobrevivir el año'];
  return <section className="w-full py-20 md:py-32 px-6 flex justify-center items-center min-h-[90vh]" data-id="element-19">
      <div className="max-w-5xl w-full flex flex-col items-center text-center md:text-left md:items-start" data-id="element-20">
        <motion.h1 className="text-gold text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 max-w-4xl" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-21">
          ¿Tu empresa de Moving compite por precio con 10 empresas más en cada
          llamada?
        </motion.h1>

        <motion.p className="text-light text-xl md:text-2xl mb-12 max-w-3xl leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} data-id="element-22">
          Llenamos tu calendario de mudanzas con clientes que valoran la
          confianza y no con personas que eligen al más barato de Google.
        </motion.p>

        <motion.div className="w-full max-w-3xl mb-12 bg-surface/50 p-6 md:p-8 rounded-xl border border-border" variants={containerVariants} initial="hidden" animate="visible" data-id="element-23">
          <ul className="space-y-4 text-left" data-id="element-24">
            {painPoints.map((point, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-4" data-id="element-25">
                <AlertTriangleIcon className="w-6 h-6 text-orange-500 shrink-0 mt-0.5" data-id="element-26" />
                <span className="text-light text-lg" data-id="element-27">{point}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div className="flex flex-col items-center md:items-start w-full" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.8,
        ease: 'easeOut'
      }} data-id="element-28">
          <CTAButton className="w-full sm:w-auto" data-id="element-29">
            QUIERO MUDANZAS CONFIRMADAS
          </CTAButton>
          <p className="text-muted text-sm mt-4" data-id="element-30">
            Diagnóstico gratuito. Sin compromiso.
          </p>
        </motion.div>
      </div>
    </section>;
}